import React from 'react';
import './LandingPage.css';
import ramada from '../assets/ramada.jpg';
import mrgamb from '../assets/mrgambstella.jpg';
import stellaProfile from '../assets/stellapp.jpg';

const LandingPage = () => {
  // Ana yönlendirme kutuları
  const mainBoxes = [
    {
      id: 1,
      imageUrl: ramada,
      link: 'https://cutt.ly/stellarmd',
      title: 'Ramada'
    },
    {
      id: 2,
      imageUrl: mrgamb,
      link: 'https://tinyurl.com/stellawin',
      title: 'Mr. Gamb'
    }
  ];

  // Sosyal medya linkleri (küçük ikonlar)
  const socialLinks = [
    {
      id: 1,
      name: 'Instagram',
      url: 'https://www.instagram.com/winxx.stellaa?igsh=cmlidXAxODFrYTU4&utm_source=qr',
      icon: 'https://cdn-icons-png.flaticon.com/512/174/174855.png',
      color: '#E4405F'
    },
    {
      id: 2,
      name: 'YouTube',
      url: 'https://youtube.com/@stellawinx2?si=sqyNr3NgsiCFTA5X',
      icon: 'https://cdn-icons-png.flaticon.com/512/174/174883.png',
      color: '#FF0000'
    },
    {
      id: 3,
      name: 'Telegram',
      url: 'https://t.me/stellawnx',
      icon: 'https://cdn-icons-png.flaticon.com/512/2111/2111646.png',
      color: '#0088CC'
    },
    {
      id: 4,
      name: 'Telegram Sohbet',
      url: 'https://t.me/stellasohbet',
      icon: 'https://cdn-icons-png.flaticon.com/512/2111/2111646.png',
      color: '#0088CC'
    },
    {
      id: 5,
      name: 'TikTok',
      url: 'https://www.tiktok.com/@winxx_stellaa?_t=ZS-8zMiulwwHSC&_r=1',
      icon: 'https://cdn-icons-png.flaticon.com/512/3046/3046121.png',
      color: '#000000'
    }
  ];

  const handleClick = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="landing-page">
      {/* STELLA Başlığı ve Profil Fotoğrafı */}
      <div className="stella-title-container">
        <div className="stella-header">
          <div className="stella-profile-container">
            <img
              src={stellaProfile}
              alt="Stella Profile"
              className="stella-profile-image"
            />
          </div>
          <div className="stella-text-section">
            <h1 className="stella-title">stella</h1>
            <p className="stella-subtitle">Güvenilir ve Kaliteli Hizmet</p>
          </div>
        </div>
      </div>

      {/* Ana yönlendirme kutuları üstte */}
      <div className="main-boxes-container">
        {mainBoxes.map(box => (
          <div
            key={box.id}
            className="main-box"
            onClick={() => handleClick(box.link)}
            style={{ backgroundImage: `url(${box.imageUrl})` }}
          >
            <div className="main-box-overlay">
              <h3 className="main-box-title">{box.title}</h3>
              <span className="main-box-arrow">→</span>
            </div>
          </div>
        ))}
      </div>

      {/* Sosyal medya ikonları altta (küçük) */}
      <div className="social-icons-bar">
        {socialLinks.map(link => (
          <div
            key={link.id}
            className="social-icon-item"
            onClick={() => handleClick(link.url)}
            style={{ '--hover-color': link.color }}
            title={link.name}
          >
            <img
              src={link.icon}
              alt={link.name}
              className="social-small-icon"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default LandingPage;
